"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeSocketAdapter = void 0;
const sample_data_1 = require("@home-health-notify/sample-data");
/* eslint-disable @typescript-eslint/no-unused-vars */
class FakeSocketAdapter {
    constructor(sendFailureResponse = false) {
        this.sendFailureResponse = sendFailureResponse;
    }
    isConnected() {
        throw new Error("Method not implemented.");
    }
    actionOnReminder(data, responseCallback) {
        throw new Error("Method not implemented.");
    }
    deleteMessage(message) {
        throw new Error("Method not implemented.");
    }
    askAcknowledgment(message) {
        throw new Error("Method not implemented.");
    }
    close() {
        return Promise.resolve(undefined);
    }
    markMessageAsRead(message, responseCallback) { }
    open(orgData, domainListener, socketNetworkListner) {
        return Promise.resolve();
    }
    sendAcknowledgment(message) {
        throw new Error("Method not implemented.");
    }
    sendMessage(message, responseCallback) {
        const mockResponse = {
            statusCode: 200,
            message: "Success",
            data: message,
        };
        const mockFailureResponse = {
            statusCode: 500,
            message: "Failed to send message",
            data: message,
        };
        const socketData = {
            data: message,
        };
        setTimeout(() => responseCallback &&
            responseCallback(this.sendFailureResponse ? mockFailureResponse : mockResponse, socketData), 100);
    }
    editMessage(message, responseCallback, _onTimeout) {
        const mockResponse = {
            statusCode: 200,
            message: "Success",
            data: message,
        };
        const mockFailureResponse = {
            statusCode: 500,
            message: "Failed to edit message",
            data: message,
        };
        const socketData = {
            data: message,
        };
        setTimeout(() => {
            responseCallback === null || responseCallback === void 0 ? void 0 : responseCallback(this.sendFailureResponse ? mockFailureResponse : mockResponse, socketData);
        }, 100);
    }
    getMediaSignedUrl(url, responseCallback) { }
    markMessageAsDelivered(message) {
        throw new Error("Method not implemented.");
    }
    forwardMessage(payload, responseCallback, onTimeout) {
        throw new Error("Method not implemented.");
    }
    withDomainListener(domainListner) {
        this.socketListener = domainListner;
        return this;
    }
    onReceivePriorityChatMessage(message, groupType, chatId) {
        const priorityMessage = Object.assign(Object.assign({}, sample_data_1.priorityTextMessageTestData), message);
        this.socketListener.onReceiveMessage({
            message: priorityMessage,
            chatLog: {
                status: message.status,
                chatType: message.chatType,
                groupType,
                from: chatId,
            },
        });
    }
    markPatientAsVisible(data, responseCallback) { }
}
exports.FakeSocketAdapter = FakeSocketAdapter;
